export default __webpack_public_path__ + "media/images/hero-e0895ec12422d3117516f2e78a263c52.jpg";